module.exports = __webpack_public_path__ + "static/img/101.a29cfe3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg/101.jpg
// module id = tMWN
// module chunks = 42